import { useEffect } from "react";
import { pick } from "lodash";
import { useApprovalStatuses, useLoadApplication } from "./fields-control";
import { useBpmFormLifecycle } from "./use-bpm-form";
import { useApplicationStore } from "app/entities/form-controller/abstract";

export function useApplicationForm<T>(form: any) {
  const { setFieldsValue, validateFields } = form;

  const store = useApplicationStore();

  const setApplicationKey = store((s) => s.setApplicationKey);
  const bpmFormData = store((s) => s.bpmStore((bpm) => bpm));
  const { setData, setFormInitialized } = store.getState();

  const initialValue = store((s) => s.initialValue);
  const cashTimeInstance = store((s) => s.cashTimeInstance);
  const fields = store((s) => s.fields);
  const defaultValues = store((s) => s.defaultValues);

  const { data, isLoading } = useLoadApplication({
    ...initialValue,
    fields,
    defaultValues,
    cashTime: cashTimeInstance,
  });
  const setDicStatuses = store((s) => s.setDicStatuses);

  useBpmFormLifecycle(form, fields, initialValue);

  const { data: statuses } = useApprovalStatuses();
  useEffect(() => {
    if (statuses?.length) {
      setDicStatuses(statuses);
    }
  }, [statuses]);

  useEffect(() => {
    if (data) {
      if (setData) {
        setData(data.dataInstance, data.formValues);
      }
      if (data.formValues && Object.keys(data.formValues).length) {
        const safeFormValues = pick(data.formValues, fields);
        setFieldsValue(safeFormValues);
        setTimeout(() => {
          setFormInitialized(true);
          console.log("isInit");
        }, 0);
      }
    }
  }, [data, fields, setFieldsValue, store]);

  return {
    bpmFormData,
    validateFields,
    setApplicationKey,
    isLoading,
  };
}
